function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 214.942l171.055-65.179 171.054 65.179"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 202.585l171.055-65.179 171.054 65.179"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 190.228l171.055-65.179 171.054 65.179"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 177.87l171.055-65.179 171.054 65.179"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 165.513l171.055-65.179 171.054 65.179"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 153.156l171.055-65.179 171.054 65.179"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 140.799L171.213 75.62l171.054 65.18"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 128.442l171.055-65.179 171.054 65.179"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 116.085l171.055-65.179 171.054 65.179"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 103.727l171.055-65.179 171.054 65.179"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 91.37l171.055-65.18 171.054 65.18"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 79.013l171.055-65.179 171.054 65.179"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M.158 66.656L171.213 1.477l171.054 65.179"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 343 216"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
};

export default __webpack_public_path__ + "static/media/parallel-lines-4-mobile.8b1ad459.svg";
export { SvgComponent as ReactComponent };